<template>
    <div class="modal fade" id="imagen_carrusel">
        <div
            class="modal-dialog modal-xl"
            role="document"
            id="modal-inspeccion"
        >
            <div class="modal-content" id="modal-img">
                <div class="modal-header">
                    <h5 class="modal-title mt-0 text-white">
                        {{ chequeoData.title }} :
                        {{ chequeoData.selector || "Vacio" }}
                        <button
                            type="button"
                            class="close mb-1"
                            id="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </h5>
                </div>
                <div class="modal-body text-center">
                    <image-zoom
                        :regular="fotos_modal"
                        :zoom="fotos_modal"
                        img-class="rounded img-fluid"
                         :zoom-amount="3"
                        hover-message="Pase el cursor para hacer zoom"
                        touch-message="Pase el cursor para hacer zoom"
                        alt="Inspección"                    >
                    </image-zoom>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import imageZoom from "vue-image-zoomer";

export default {
    components: {
        imageZoom
    },
    computed: {
        chequeoData() {
            if (this.isCarpeta) {
                return this.$store.state.adminventa_carpeta.chequeo_card;
            } else {
                return this.$store.state.proceso.chequeo_card;
            }
        },
        ...mapFields("fichaTecnica", ["fotos_modal"])
    }
};
</script>

<style lang="scss">
div#modal-inspeccion {
    width: 100%;
}
div#modal-img {
    transition: opacity 0.2s ease;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: table;
    border-color: rgba(0, 0, 0, 0.8);
}
*,
::after,
::before {
    box-sizing: border-box;
}
button#close {
    background: #0000;
    font-size: 25px;
    margin-top: 0px;
}
img.rounded.img-fluid {
    max-width: 100%;
    height: 450px;
    max-height: 100%;
    margin-bottom: .5rem;
    min-height: auto;
}
</style>
